
Monet.Format = Monet.Format || {};
Monet.Format.RATING = (function () {

  function RATING(value, dataContext) {
    Monet.Format.Base.apply(this, arguments);

    const rating = new Monet.UI.Fields.Rating();
    const commentListener = 'Greenmile.Rating.Comment(this)';

    this.toGrid = function () {
      rating.setValue(value);
      rating.disabled = true;
      this.value = rating.render(commentListener, dataContext).outerHTML;
      return this;
    };

    this.getValue = function () {
      if (!this.value) {
        this.value = '';
      }
      return this.value;
    };
  }

  return RATING;

}());